import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SrcErrorDirective } from './src-error/src-error.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [SrcErrorDirective],
  exports: [SrcErrorDirective],
})
export class SharedDirectivesSrcErrorModule {}
